// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__IXb8k","pulse":"nav_pulse__bHckZ","pulseFast":"nav_pulseFast__noNtk","background":"nav_background__GA9HE","cta":"nav_cta__yAOXf"};